import { Button } from "@platform/design-system";

type FormFooterProps = {
  confirmButtonLabel: string;
  onClickConfirm: () => void;
  onCloseDrawer: () => void;
  disabled: boolean;
};

export const FormFooter: React.FC<FormFooterProps> = ({
  disabled,
  onClickConfirm,
  onCloseDrawer,
  confirmButtonLabel,
}) => (
  <>
    <Button variant="tertiary" size="sm" onClick={onCloseDrawer}>
      Cancel
    </Button>
    <Button size="sm" disabled={disabled} onClick={onClickConfirm}>
      {confirmButtonLabel}
    </Button>
  </>
);

type AddNewBusinessFormFooterProps = {
  step: number;
  confirmButtonLabel: string;
  onCloseDrawer: () => void;
  onNext: () => void;
  onSave: () => void;
  onSaveAndAddAnother: () => void;
  confirmButtonDisabled: boolean;
  isSaving?: boolean;
};

export const AddNewBusinessFormFooter: React.FC<
  AddNewBusinessFormFooterProps
> = ({
  step,
  confirmButtonLabel,
  onCloseDrawer,
  onNext,
  onSave,
  onSaveAndAddAnother,
  confirmButtonDisabled,
}) => (
  <>
    <Button variant="tertiary" size="sm" onClick={() => onCloseDrawer()}>
      Cancel
    </Button>

    {step === 2 && (
      <Button
        size="sm"
        variant="secondary"
        onClick={onSaveAndAddAnother}
        disabled={confirmButtonDisabled}
      >
        Save and add another
      </Button>
    )}

    <Button
      size="sm"
      onClick={step === 1 ? onNext : onSave}
      disabled={confirmButtonDisabled}
    >
      {step === 1 ? confirmButtonLabel : "Save"}
    </Button>
  </>
);
